import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  VERIFY_REQUEST,
  VERIFY_SUCCESS,
  SIGN_OUT_USER,
  AUTH_USER,
  TYPE_VERIFY_USER,
  SET_BROWSER_LOCATION,
  SET_LANDING_LAWYERS,
} from "../actions/UserAction";
import { USER_STATUS } from "../../types/UserTypes";


/* let user = JSON.parse(localStorage.getItem('user'));
 */
/* const INITIAL_STATE = user ? { users: user, isLoggingIn: true } : {  users: null,isLoggingIn: false  };
 */const INITIAL_STATE = {
  isLoggingIn: false,
  isLoggingOut: false,
  isVerifying: false,
  loginError: false,
  logoutError: false,
  isAuthenticated: false,
  user: {},
  statusUser: '',
  browserLocation: '',
  };


  const userReducer = (state = INITIAL_STATE, action) => {

  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        isLoggingIn: true,
        loginError: false
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoggingIn: false,
        isAuthenticated: true,
        user: action.user
      };
    case AUTH_USER:
      return {
        ...state,
          statusUser: action.data ? USER_STATUS.logged : USER_STATUS.notFound,
        error: null
    };
    case TYPE_VERIFY_USER:
      return {
        ...state,
        typeUser:action.data
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        isLoggingIn: false,
        isAuthenticated: false,
        loginError: true
      };
    case LOGOUT_REQUEST:
      return {
        ...state,
        isLoggingOut: true,
        logoutError: false
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        isLoggingOut: false,
        isAuthenticated: false,
        user: {},
      };
    case LOGOUT_FAILURE:
      return {
        ...state,
        isLoggingOut: false,
        logoutError: true
      };
    case VERIFY_REQUEST:
      return {
        ...state,
        isVerifying: true,
        verifyingError: false
      };
    case VERIFY_SUCCESS:
      return {
        ...state,
        isVerifying: false
      };
    case SIGN_OUT_USER:
      return {
        ...state,
        authenticated: false,
        error: null,
        statusUser: USER_STATUS.notFound,

      };
    case SET_BROWSER_LOCATION:
      return {
        ...state,
        browserLocation: action.data,
      };
    case SET_LANDING_LAWYERS:
      return {
        ...state,
        landingLawyers: action.data.lawyers,
        landingLawfirms: action.data.lawfirms,
      }
    default:
      return state;
  }
};
/* 
  const applySetUsers = (state, action) => ({
    ...state,
    users: action.users,
  });
  const applySetUser = (state, action) => ({
    ...state,
    users: {
      ...state.users,
      [action.uid]: action.user,
    },
  });
  function userReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
      case 'USERS_SET': {
        return applySetUsers(state, action);
      }
      case 'USER_SET': {
        return applySetUser(state, action);
      }
      default:
        return state;
    }
  } 
  
  export default userReducer;*/

  export default userReducer;